import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../_services/auth.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const excluded = ['/auth/login', '/auth/signup', '/auth/verifyOtp'];
  if (!auth.isBrowser() || excluded.some(path => req.url.includes(path)) || req.headers.has('Authorization')) {
    return next(req);
  }
  // Prefer the separately stored token; support sessions created by the legacy login API.
  const stored = localStorage.getItem('Cirlced_User');
  const user = stored ? JSON.parse(stored) : null;
  const token = auth.getAccessToken() ?? user?.token;
  return next(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req);
};
